export default __webpack_public_path__ + "static/media/gloves_of_vengeful_zeal.91f6f912.jpg";